import { MidpointRoundingType } from './midpoint';
import Decimal from 'decimal.js-light';

const roundSf = (value, precision, midpoint = MidpointRoundingType.ToEven) => {
  let decimal = new Decimal(value);

  if (midpoint === MidpointRoundingType.AwayFromZero)
    return decimal.toSignificantDigits(precision, Decimal.ROUND_HALF_UP).toNumber();
  else return decimal.toSignificantDigits(precision, Decimal.ROUND_HALF_EVEN).toNumber();
};

export default roundSf;
